import { createSelector } from 'reselect';

const selectUploadFiles = (state: any) => state.uploadFiles;


export const selectUploadFilesCurrentItem = createSelector([selectUploadFiles], (uploadFiles) => uploadFiles.current);

export const selectUploadFilesListItems = createSelector([selectUploadFiles], (uploadFiles) => uploadFiles.list);

export const selectUploadFileItemById = (itemId: any) =>
    createSelector(selectUploadFilesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectUploadFileQueryItems = createSelector([selectUploadFiles], (uploadFiles) => uploadFiles.query);

export const selectUploadFileCreatedItem = createSelector([selectUploadFiles], (uploadFiles) => uploadFiles.create);

export const selectUploadFileUpdatedItem = createSelector([selectUploadFiles], (uploadFiles) => uploadFiles.update);

export const selectReadItem = createSelector([selectUploadFiles], (uploadFiles) => uploadFiles.read);

export const selectUploadFileDeletedItem = createSelector([selectUploadFiles], (uploadFiles) => uploadFiles.delete);

export const selectUploadFileSearchedItems = createSelector([selectUploadFiles], (uploadFiles) => uploadFiles.search);

export const selectUploadFileItemsCount = createSelector([selectUploadFiles], (uploadFiles) => uploadFiles.count);

export const selectUploadFileItemsFilter = createSelector([selectUploadFiles], (uploadFiles) => uploadFiles.filter);